var Haiku = require("@haiku/core");
module.exports = {
  metadata: {
    uuid: "67a900ef-ed0f-491d-bee4-d8a023cf6ea0",
    version: "0.0.1",
    organization: "Tina",
    project: "AnimatorWebsiteIcon2",
    branch: "master",
    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon2",
    username: "tina@haiku.ai",
    root: "https://cdn.haiku.ai/9fec979d-d44c-4994-b16b-ee78d60c5e95/5f95a2978fb21498c9f76103836200625255c63b/",
    core: "4.5.0",
    title: "Deco2",
    type: "haiku",
    relpath: "code/deco2/code.js"
  },
  options: {},
  states: {},
  eventHandlers: {},
  timelines: {
    Default: {
      "haiku:Deco2-20cb245cfb651e73": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "visible",
        "style.overflowY": "visible",
        "sizeAbsolute.x": 8.666,
        "sizeAbsolute.y": 8.321,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:7eaee227506e": {
        "sizeAbsolute.y": 7,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 7,
        "sizeMode.x": 1,
        "style.margin": "0",
        "sizeMode.y": 1,
        "translation.x": 4.333,
        "translation.y": 4.160499999999999,
        "style.zIndex": 4,
        "rotation.z": {
          "0": { value: 0, edited: true, curve: "linear" },
          "667": { value: 6.284 }
        }
      },
      "haiku:61060159ee1d": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:818bdcfdd51d": {
        fill: "#A3CE32",
        "translation.x": -7,
        "translation.y": -4
      },
      "haiku:ac405177b446": {
        x: 7.32893795,
        y: 4.78998906,
        width: 5.94212411,
        height: 5.94212411,
        rx: 1,
        "translation.x": 0.420298,
        "translation.y": -0.528424,
        "rotation.z": 0.05236
      }
    }
  },
  template: {
    elementName: "div",
    attributes: {
      "haiku-id": "Deco2-20cb245cfb651e73",
      "haiku-title": "Deco2"
    },
    children: [
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "7eaee227506e",
          "haiku-title": "deco2",
          "haiku-source":
            "designs/AnimatorWebsiteIcon2.sketch.contents/slices/deco2.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: {
              "haiku-id": "61060159ee1d",
              "haiku-title": "Page-1",
              id: "fc88fb5fbeef"
            },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "818bdcfdd51d",
                  "haiku-title": "HaikuCore-icon",
                  id: "61a7d42c98f5"
                },
                children: [
                  {
                    elementName: "rect",
                    attributes: {
                      "haiku-id": "ac405177b446",
                      "haiku-title": "deco2",
                      id: "0d6d88e8fc0a"
                    },
                    children: []
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/tina-animatorwebsiteicon2/code/deco2/code.js
// module id = 433
// module chunks = 35783957827783